<template>
  <div class="cityAreaList" @scroll="onScroll">
    <sticky-select
      :activeIndex="activeIndex"
      :areaList="optionList"
      @change="searchRefundList"
     />
    <div class="list-contaienr">
      <div class="card" @click="toDetail(item)"  v-for="(item, index) in refundList" :key="index">
        <div class="title-box">
          <div class="title one-txt-cut">{{ item.title }}</div>
          <div
              :class="[
                'tag',
                statusOptions[item.status] && statusOptions[item.status].color,
              ]"
            >
            {{ item.statusText }}
          </div>
        </div>

        <div class="content-box">
          <table>
            <tr>
              <td>退货人：</td>
              <td>{{ item.returnUser }}</td>
            </tr>
            <tr>
              <td>购买区域：</td>
              <td>{{ item.region }}</td>
            </tr>
            <tr>
              <td>销售企业：</td>
              <td>{{ item.salesEnterprise }}</td>
            </tr>
            <tr>
              <td>申请日期：</td>
              <td>{{ item.createTime }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="card" v-if="!refundList.length && !loading">
        暂无数据
      </div>
    </div>

    <div v-if="haveNewData" @click="fresh" class="toast">
      <span class="text1">收到新的退货申请，</span>
      <span class="text2">立即刷新</span>
    </div>
  </div>
</template>

<script>
    import api from '@/service/modules/refund';
    import moment from 'moment';
    import stickySelect from '../components/stickySelect.vue';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        data () {
            return {
                loading: false,
                activeIndex: 0,
                queryType: '',
                areaName: '',
                total: 0,
                pageParams: {
                    orderBy: '',
                    searchStr: '',
                    status: '',
                    pick: '',
                    areaId: this.$store.state.refund.statisticalAnalysisReginCode,
                    timeArr: '',
                    startDate: '',
                    endDate: '',
                    pageIndex: 1,
                    pageSize: 10
                },
                pageination: {},
                optionList: [],
                refundList: [],
                lastTotal: 0, // 上一次数据量，用来轮询判断是否有新单
                haveNewData: false,
                timer: null
            };
        },
        components: {
            stickySelect
        },
        mounted () {
          this.setIntervalgetdata()
            window.addEventListener("scroll", this.getbottom);

        },
        computed: {
            ...mapGetters('refund', {
                dictType: 'getDictType'
                // currentUser: "getCurrentUser", // 当前用户信息
                // isRegulatoryUser: "isRegulatoryUser", // 是否是监管者权限
            }),

            statusOptions () {
                const colorMap = ['orange', 'blue', 'grey'];
                const map = {};

                this.dictType &&
                    this.dictType.WORK_ORDER_FLOW.forEach((item) => {
                        switch (item.name) {
                        case '已关闭':
                            map[item.code] = { label: item.name, color: colorMap[2] };
                            break;

                        default:
                            map[item.code] = { label: item.name, color: colorMap[0] };
                            break;
                        }
                    });
                return map;
            }
        },
        created () {

            let queryParams = this.$route.query;
            this.optionList = JSON.parse(sessionStorage.getItem('optionList'));
            this.areaName = queryParams.areaName;
            this.queryType = queryParams.queryType;

             if (localStorage.getItem('activeIndex')) {
              this.activeIndex = Number(localStorage.getItem('activeIndex'))
              localStorage.removeItem('activeIndex')
            } else {
              this.activeIndex = Number(queryParams.activeIndex);
            }

            Object.keys(this.optionList[this.activeIndex]).forEach((key) => {
                if (key != 'F_NAME' && key != 'count') {
                    this.pageParams[key] = this.optionList[this.activeIndex][key];
                }
            });

            this.pageParams.startDate = queryParams.startTime || ''
            this.pageParams.endDate = queryParams.endTime || ''
            this.currentUser();
        },
        destroyed(){
          clearInterval(this.timer);
          this.timer = null;
          window.removeEventListener("scroll", this.getbottom);
        },
        beforeRouteEnter(to, from, next) {
            if (from.path === '/refund/refundDetail') {
              next(vm => {
                window.addEventListener("scroll", vm.getbottom);
                vm.refundList = JSON.parse(localStorage.getItem('datalist'))
                localStorage.removeItem('datalist')
                document.body.scrollTop = localStorage.getItem('scrollTop')
                localStorage.removeItem('scrollTop')
              })
            } else {
              next()
            }
        },
        beforeRouteLeave(to, from, next) {
            if (to.path === '/refund/refundDetail') {
              localStorage.setItem('datalist', JSON.stringify(this.refundList))
              localStorage.setItem('scrollTop', document.body.scrollTop)
              localStorage.setItem('activeIndex', this.activeIndex)
            }

          clearInterval(this.timer);
          this.timer = null;
          window.removeEventListener("scroll", this.getbottom);
          next()
        },
        methods: {
            ...mapActions('refund', {
                setDictType: 'setDictType'
            }),
              setIntervalgetdata() {
               this.timer = setInterval(() => {
                this.setIntervalGetData()
              }, 5 * 1000)
            },
            fresh() {
              this.haveNewData = false
              // this.getList()
              this.$router.go(0)
            },
            async setIntervalGetData() {
                const params = {
                    ...this._.cloneDeep(this.pageParams)
                };
                delete params.timeArr;

                const { data } = await api.getRefundList(params);
            // 判断数据长度看是否有新单
            if (this.lastTotal === 0) {
            this.lastTotal = data.pageination.total
            } else {
              if (data.pageination.total != this.lastTotal) {
                this.lastTotal = data.pageination.total
                this.haveNewData = true
                console.log('有新单');
              } else {
                this.haveNewData = false

                console.log('没新单');
              }
            }
          },
               getbottom() {
                this.onScroll()
               },
            async onScroll (e) {
                // const scrollTop = e.target.scrollTop;
                const scrollTop = document.documentElement.scrollTop||document.body.scrollTop
                if (scrollTop < 10) {
                    this.pageParams.pageIndex = 1;
                    const newList = await this.getNewPageList();
                    this.$set(this, 'refundList', newList);
                } else {
                  if (
                      this.pageParams.pageIndex * this.pageParams.pageSize >=
                      this.pageination.total
                  ) { return; }
                  if (
                      scrollTop >
                      this.pageParams.pageIndex * this.pageParams.pageSize * 150 - 900
                  ) {
                      this.pageParams.pageIndex++;
                      const newList = await this.getNewPageList();
  
                      const list = this.refundList.concat(newList);
                      this.$set(this, 'refundList', list);
                  }

                }
            },
            async currentUser () {
                api.currentUser().then((res) => {
                    if (res.ret === 0) {
                        // this.pageParams.areaId = res.data.regionCode;
                    }
                });
                 if (localStorage.getItem('datalist')) {
                    console.log('获取缓存');
                    this.refundList = JSON.parse(localStorage.getItem('datalist'))
                  } else {
                    try {
                        this.dictType || (await this.setDictType());
                        this.getRefundList();
                    } catch (err) {
                        this.getRefundList();
                    }
                  }
            },
    
            async getRefundList () {
                const params = {
                    ...this._.cloneDeep(this.pageParams)
                };
                delete params.timeArr;

                const { data } = await api.getRefundList(params);

                this.lastTotal = data.pageination.total
                
                const list = data.list.map((item) => ({
                    title: item.product,
                    flowId: item.flowId,
                    status: item.status,
                    statusText: item.statusText,
                    returnUser: item.submitUser,
                    region: item.cityName + '-' + item.areaName,
                    salesEnterprise: item.shoppingStore,
                    createTime: moment(item.refundTime).format('YYYY年MM月DD日')
                }));
                this.$set(this, 'refundList', list);
                this.$set(this, 'pageination', data.pageination);
                this.loading = false;
            },
            async getNewPageList () {
                const params = {
                    ...this._.cloneDeep(this.pageParams)
                };
                delete params.timeArr;

                const { data } = await api.getRefundList(params);
                const list = data.list.map((item) => ({
                    title: item.product,
                    flowId: item.flowId,
                    status: item.status,
                    statusText: item.statusText,
                    returnUser: item.submitUser,
                    region: item.cityName + '-' + item.areaName,
                    salesEnterprise: item.shoppingStore,
                    createTime: moment(item.refundTime).format('YYYY年MM月DD日')
                }));

                this.$set(this, 'pageination', data.pageination);
                return list;
            },
            // 搜索对应数据的退货列表
            searchRefundList (item, index) {
                this.activeIndex = index
                this.pageParams.areaId = this.$store.state.refund.statisticalAnalysisReginCode
                this.loading = true;
                this.refundList = [];
                this.pageParams.pageIndex = 1;
                Object.keys(item).forEach((key) => {
                    if (key != 'F_NAME' && key != 'count') {
                        this.pageParams[key] = item[key];
                    }
                });
                this.getRefundList();
            },
            toDetail (item) {
                this.$router.push({
                    path: '/refund/refundDetail',
                    query: {
                        flowId: item.flowId
                    }
                })
            }
        }
    };
</script>

<style lang="less" scoped>
.cityAreaList {
  // height: 100%;
  display: flex;
  flex-flow: column nowrap;
  // overflow: auto;
  background-color: #f9fafc;
  
   .toast {
    opacity: 0.8;
    background: #1E2226;
    position: fixed;
    border-radius: 3px;
    width: 58%;
    left: 50%;
    transform: translateX(-50%);
    bottom: 75px;
    text-align: center;
    padding: 0 16px;
    .text1 {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 34px;
    }
    .text2 {
      line-height: 34px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #5EE4A0;
    }
  }
  /deep/.van-tab {
    padding: 13px 16px 0;
    p {
      font-size: 12px;
      color: #71747A;
    }
  }

  /deep/.van-tab--active {
    p {
      font-weight: 600;
      color: #229F60;
    }
  }
  .list-contaienr {
    padding: 0 12px 12px;
  }
  // /deep/.van-tabs__line {
  //   width: 20px !important;
  //   transform: translateX(38.5px) translateX(-50%);
  //   background-color: #36B374;
  // }
  .card {
    margin-top: 12px;
    padding: 14px 12px 16px;
    background: #ffffff;
    border-radius: 3px;

    .title-box {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      .title {
        flex: 1;
        height: 16px;
        font-family: PingFangSC-Medium;
        font-weight: Medium;
        font-size: 16px;
        color: #1e2226;
        letter-spacing: 0;
        line-height: 16px;
        filter: blur(10);
      }

      .tag {
        height: 18px;
        border-radius: 1px;
        padding: 0 4px;
        margin-left: 10px;

        font-family: PingFangSC-Regular;
        font-weight: Regular;
        font-size: 12px;
        letter-spacing: 0;
        line-height: 18px;
        filter: blur(10);
      }

      .orange {
        // border: 1px solid #ff9f3f;
        color: #ff9f3f;
      }

      .blue {
        // border: 1px solid #4197ef;
        color: #4197ef;
      }

      .grey {
        // border: 1px solid #c8c9cc;
        color: #9da0a4;
      }
    }

    .content-box {
      margin-top: 10px;
      font-size: 12px;
      line-height: 17px;
      color: #71747a;
      letter-spacing: 0;
      filter: blur(10);
      table {
        tr {
          line-height: 19px;
          td {
            &:first-child {
              min-width: 60px;
              vertical-align: top;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
}
</style>
